import React, { memo } from "react"

import PropTypes from "prop-types"

import { getSuggestionValue } from "@utils/gamePlanUtils"

import TitleMessage from "../statusMessage/titleMessage"

const TYPE_LABELS = { when: "When", where: "Where" }

const GameplanUpdateMessage = ({ item, people, suggestions }) => {
  const { isDecided, suggestionId } = item
  const suggestion = suggestions[suggestionId] || {}
  const { type } = suggestion

  const user = people[item.senderId]
  const label = TYPE_LABELS[type] || type
  // FIX 3 (2026-07-04, banned Ale concept): "Decided" is one of Ale's state/lock terms we do not
  // carry into our build (QJ). This is the narrative row for a decided/undecided Game Plan item,
  // so it reads as a plain sentence -- "X set the When" / "X reopened the Where" -- never the
  // word "Decided"/"Undecided". getSuggestionValue(...).full gives the same
  // "Sat, Jul 4, 3:00pm - 4:00pm" (or place name) text already shown on the suggestion row
  // itself, appended for context on the "set" case.
  const value = getSuggestionValue(suggestion, type).full
  const text = isDecided
    ? `${user?.username || user?.name} set the ${label}${value ? `: ${value}` : ""}`
    : `${user?.username || user?.name} reopened the ${label}`

  return (
    <TitleMessage
      text={text}
      item={item}
      senders={[user]}
      containerStyle={containerStyle}
      isGameplanUpdate
    />
  )
}

GameplanUpdateMessage.propTypes = {
  item: PropTypes.object.isRequired,
  people: PropTypes.object.isRequired,
  suggestions: PropTypes.object.isRequired,
  isGameplanUpdate: PropTypes.bool,
}

export default memo(GameplanUpdateMessage)

const containerStyle = {
  paddingHotizontal: 8,
  paddingVertical: 8,
  marginHorizontal: 8,
}
